import React from 'react'
import { Link } from "react-router-dom"
import { Row, Col, Typography, Space} from 'antd'

import FeatureSearch from '../images/tools/feature_search.png'
import Blast from '../images/tools/blast.png'
import Synteny from '../images/tools/synteny.png'
import JBrowse from '../images/tools/jbrowse.png'
import WashU from '../images/tools/washu.png'
import Primer3 from '../images/tools/primer3.png'
import Vigs from '../images/tools/vigs.png'
import RefExpression from '../images/tools/ref_expression.png'
import PopExpression from '../images/tools/pop_expression.png'
import Crispr from '../images/tools/crispr.png'
import GWAS_Single from '../images/tools/GWAS-single.png'
import GWAS_Multi from '../images/tools/GWAS-multi.png'
import GWAS_Locus from '../images/tools/GWAS-locus.png'
import eQTL from '../images/tools/eQTL.png'
import MapViewer from '../images/tools/map_viewer.png'
import Haplotype from '../images/tools/haplotype.png'
import Phenotype from '../images/tools/phenotype.png'
import Download from '../images/tools/download.png'

const { Title } = Typography

class Tools extends React.Component {
    state = {
        tools_title: 'Tools'
    }

    componentDidMount() {
        const tools = document.querySelectorAll(".tools a")
        tools.forEach(item => {
            item.addEventListener('mouseover', e => {
                const tool_title = e.target.getAttribute('tool_title')
                const tools_title = 'Tools' + ' - ' + tool_title

                this.setState({tools_title: tools_title})
            })

            item.addEventListener('mouseout', e => {
                this.setState({tools_title: 'Tools'})
            })
        })
    }

    render() {
        const { tools_title } = this.state
        return (
            <React.Fragment>
                <Title level={3} className="tools-title">{tools_title}</Title>
                <Row className="tools">
                    <Col>
                        <Space size="large">
                            <Col span={2}>
                                <Link to="/search/feature"><img className="tools-img" src={FeatureSearch} width={75} tool_title="Search Feature" /></Link>
                            </Col>
                            <Col span={2}>
                                <a href="/tomato/tool/blast" target="_blank"><img className="tools-img" src={Blast} width={75} tool_title="Blast" /></a>
                            </Col>
                            <Col span={2}>
                                <Link to="/tool/jbrowse_nav"><img className="tools-img" src={JBrowse} width={75} tool_title="JBrowse" /></Link>
                            </Col>
                            <Col span={2}>
                                <a href="/tomato/tool/primer3" target="_blank"><img className="tools-img" src={Primer3} width={75} tool_title="Primer3" /></a>
                            </Col>
                        </Space>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }
}

export default Tools
